module.exports = __webpack_public_path__ + "img/suwako moriya_sc1.eae74cce.png";